<!--
@Author: cjhgit jhcuil@outlook.com
@Date: 2024-12-18 13:41:29
 ** @LastEditors: cjhgit jhcuil@outlook.com
 ** @LastEditTime: 2025-04-03 17:16:47
 ** @FilePath: \sqm-element\src\components\isFactoryvisualEye\index.vue
@Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->

<template>
  <h-list-page class="isFactoryvisualEye_style">
    <h-card :title="h_i18n('acc0e2103f1a99a5e4b663c67fa3cca8')" width="100%" is-search @change-method="changeMethod">
      <h-area>
        <h-search :title="h_i18n('b9211b0f5ff87bdd4646f7e81e5efecc')">
          <h-input v-model="searchData.factoryName" clearable
                   @change="changeNull(searchData.factoryName, 'factoryName')"></h-input>
        </h-search>

        <template #operate>
          <h-button type="primary" :loading="data.loading" @click="getInfo(true)">
            <template #icon>
              <search />
            </template>{{ h_i18n('bee912d79eefb7335988c4997aa9138d') }}</h-button>
        </template>

      </h-area>
    </h-card>
    <h-table-card :title="h_i18n('acc0e2103f1a99a5e4b663c67fa3cca8')" :is-left="0" :h-data="data.tableData">
      <template #buttonGroup>
        <h-button-group>
          <template v-for="item in data.btnListOfSqm" :key="item.code">
            <h-button type="primary" v-if="item.code == 'mkhl_cctyks_cctyks_insert'"
                      :loading="loadingFunction(item.code)" @click="btnFunction(item.code)">
              <template #icon>
                <Newlybuild />
              </template>{{ h_i18n('397a13e6ca2b65d06d23a668703c7c4d') }}</h-button>
          </template>
        </h-button-group>
      </template>

      <el-table :empty-text="h_i18n('71de786302ccfb91781f054c4fd02ec8')" :data="data.tableData" height="520" @selection-change="listCheckBoxChange" border
                v-loading="data.tableLoading" size="small" style="width: 100%; min-height: 520px">
        <el-table-column type="index" :label="h_i18n('faaadc447b1c2b1adc920d9c9aedcc25')" width="48"></el-table-column>
        <el-table-column prop="monitorState" :label="h_i18n('66e52127c06b44b746f3514c613ab509')" width="100">
          <template #default="{row}">
            <span v-if="row.monitorState == 0">正常</span>
            <span v-if="row.monitorState == 1" style="color:red">异常</span>
          </template>
        </el-table-column>
        <el-table-column prop="errorMsg" :label="h_i18n('4694e64c666a3b74ba7a38595e2b200d')" width="100">
          <template #default="{row}">
            <span v-if="row.errorMsg === '无'">{{ row.errorMsg }}</span>
            <span v-else-if="row.errorMsg === null">{{ h_i18n('d81bb206a889656035b929cd8bb1ef10') }}</span>
            <span v-else style="color:red;">{{ row.errorMsg }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="supplyName" :label="h_i18n('9190cc22c9ba377113bc54ac51013a0b')" min-width="168"></el-table-column>
        <el-table-column prop="supplyCode" :label="h_i18n('1b7ecd2bdbd8a1a112dead57724f06df')" min-width="98"></el-table-column>
        <el-table-column prop="factoryName" :label="h_i18n('b9211b0f5ff87bdd4646f7e81e5efecc')" min-width="148"></el-table-column>
        <el-table-column prop="factoryProvince" :label="h_i18n('3d14d1a1f9514183570a10fe80a32384')" min-width="88"></el-table-column>
        <el-table-column prop="factoryCity" :label="h_i18n('371528ffb7f95c7fddc0d60249e716ec')" min-width="88"></el-table-column>
        <el-table-column prop="factoryArea" :label="h_i18n('47c762206773ddd95bc0757bae8b33d7')" min-width="88"></el-table-column>
        <el-table-column prop="subDistrict" :label="h_i18n('716c3dc1bd990ccebc4fee34eb9171cf')" min-width="108"></el-table-column>
        <el-table-column prop="detailedAddress" :label="h_i18n('7650487a8758fd50c87d6c9cff0aa5ac')" min-width="148">
          <template #default="{ row }">
            <Encryption :encData="row.detailedAddressDecrypt" :encKey="row.detailedAddress"
            :supplyData="{supplyCode:row.supplyCode,supplyName:row.factoryName}" :name="'天眼可视'"></Encryption>
          </template>
        </el-table-column>
        <el-table-column prop="equipmentModel" :label="h_i18n('5858832b73994f164473bd888fd98eea')" min-width="108">
          <template #default="{ row }">
            <span>{{ row.equipmentModel || '-' }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="channelNo" :label="h_i18n('95559444109d4dcb9322ae8aeac7db73')" min-width="68">
          <template #default="{ row }">
            <span>{{ row.channelNo || '-' }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="yingshiStatus" :label="h_i18n('a93c2bd3c83630e3508fa75ad1d9b7dc')" min-width="98">
          <template #default="{ row }">
            <span v-if="row.yingshiStatus === '0'">{{ h_i18n('906ad18b48f07a0cc2ea9f4f809e1254') }}</span>
            <span v-if="row.yingshiStatus === '1'">{{ h_i18n('aa71a61cef0adb769436cde6d379b02c') }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="isrtEmpId" :label="h_i18n('95a43eaa59198a9a2f5271e4ab593593')" min-width="68"></el-table-column>
        <el-table-column prop="isrtDate" :label="h_i18n('eca37cb0726c51702f70c486c1c38cf3')" min-width="168">
          <template #default="{ row }">
            <span>{{ time(row.isrtDate, 6) }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="operation" :label="h_i18n('2b6bc0f293f5ca01b006206c2535ccbc')" min-width="100">
          <template #default="{ row }">
            <a style="margin-right:1px;color:#165dff; cursor: pointer;"
               @click="creatNewFactoryShow('change', row.id, row)">{{ h_i18n('8347a927c09a4ec2fe473b0a93f667d0') }}</a>
            <a style="color:#165dff; cursor: pointer;margin-left: 10px;" @click="live(row)">{{ h_i18n('b85270cd3c06d8eb635eadcffbb10119') }}</a>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination background @size-change="handleSizeChange" @current-change="getInfo"
                     v-model:currentPage="searchData.pageNo" :page-size="searchData.pageSize"
                     layout="total, prev, pager, next,jumper" :total="data.total">
      </el-pagination>

    </h-table-card>

    <h-dialog width="752px" :title="data.makeFactoryTitle" :show="data.newFactoryFlag" footer
              class="dialog_factoryvisualeye_style" @close="clearData" @ok="handleOkOfFactory">
      <h-row>
        <h-col :span="12">
          <h-search :title="h_i18n('b9211b0f5ff87bdd4646f7e81e5efecc')">
            <h-input showCount :maxlength="20" allowClear v-model="data.addData.factoryName"
                     :placeholder="h_i18n('2179e04b069fe7d20d2af0f68991f300')"></h-input>
          </h-search>
        </h-col>
        <h-col :span="11">
          <h-search :title="h_i18n('41913f24b0842a07ff5757ba37910e06')">
            <h-select :placeholder="h_i18n('708c9d6d2ad108ab2c560530810deae9')" filterable v-model="data.addData.factoryProvince" @change="changeProvince">
              <h-option v-for="item in data.provinceList" :key="item.name" :label="item.name" :value="item.name">
              </h-option>
            </h-select>
          </h-search>
        </h-col>
      </h-row>
      <h-row>
        <h-col :span="12">
          <h-search :title="h_i18n('ba6a6f2cdb46e8f80fbfd4fed20eafac')">
            <h-select :disabled="cityFlag" filterable :placeholder="placeHolderMsg" v-model="data.addData.factoryCity"
                      @change="changeCity" @click="changeClick('factoryCity')">
              <h-option v-for="item in data.cityList" :key="item.name" :label="item.name" :value="item.name">
              </h-option>
            </h-select>
          </h-search>
        </h-col>
        <h-col :span="11">
          <h-search :title="h_i18n('9b711a7b854bda16a2339fc9bb887736')">
            <h-select :disabled="areaFlag" filterable :placeholder="placeHolderMsg" v-model="data.addData.factoryArea"
                      @change="changeArea" @click="changeClick('factoryArea')">
              <h-option v-for="item in data.areaList" :key="item.name" :label="item.name" :value="item.name">
              </h-option>
            </h-select>
          </h-search>
        </h-col>
      </h-row>
      <h-row>
        <h-col :span="12">
          <h-search :title="h_i18n('050be593da24c47dd95493b19e687e0f')">
            <h-select :disabled="subDistrictFlag" filterable :placeholder="placeHolderMsg" v-model="data.addData.subDistrict"
                      @change="changeStreet" @click="changeClick('subDistrict')">
              <h-option v-for="item in data.streetList" :key="item.name" :label="item.name" :value="item.name">
              </h-option>
            </h-select>
          </h-search>
        </h-col>
        <h-col :span="11">

        </h-col>
      </h-row>
      <h-row>
        <h-col :span="23">
          <!-- 详细地址 -->
          <h-search :title="h_i18n('61a0ec8a090e2ea2d973d9ec9d0dac2b')">
            <el-input type="textarea" :style="`--content:'${h_i18n('61a0ec8a090e2ea2d973d9ec9d0dac2b')}'`" :maxlength="100" showCount v-model="data.addData.detailedAddress"
                      :placeholder="h_i18n('80d6852f33be98a024f8e28128ee63ed')" :auto-size="{ minRows: 3, maxRows: 5 }"
                      style="width:100%;min-height: 50px; border-radius:4px;"></el-input>
          </h-search>
        </h-col>
      </h-row>
      <h-row>
        <h-col :span="12">
          <h-search title="AppKey">
            <h-input allowClear v-model="data.addData.appKey" :placeholder="h_i18n('571bb2d9866b69c543b6fae837641060')"></h-input>
          </h-search>
        </h-col>
        <h-col :span="11">
          <h-search title="Secret">
            <h-input allowClear v-model="data.addData.secret" :placeholder="h_i18n('6cc0b20df938435d79ca718e60fd7592')"></h-input>
          </h-search>
        </h-col>
      </h-row>
      <h-row>
        <h-col :span="12">
          <h-search :title="h_i18n('4419e8a1ba26ab60adc3572dcd5be78c')">
            <h-input allowClear v-model="data.addData.deviceSerial" :placeholder="h_i18n('007aeb71de765993f8bbde4635a42d04')"></h-input>
          </h-search>
        </h-col>
        <h-col :span="11">
          <h-search :title="h_i18n('95559444109d4dcb9322ae8aeac7db73')">
            <h-input allowClear v-model="data.addData.channelNo" :min="0" :precision="0" :controls="false"
                     :placeholder="h_i18n('52f158385dad6790899c14b1f8c6acab')" @blur="inputNumberChange"></h-input>
          </h-search>
        </h-col>
      </h-row>
      <h-row>
        <h-col :span="12">
          <h-search :title="h_i18n('5858832b73994f164473bd888fd98eea')">
            <h-input allowClear v-model="data.addData.equipmentModel" :placeholder="h_i18n('dfc894e3592ab700f7a1e94523519341')"></h-input>
          </h-search>
        </h-col>
        <h-col :span="11">

        </h-col>
      </h-row>
      <h-row>
        <h-col :span="12">
          <a v-intercept-href href="https://sqm.haier.net/readFile/basicInfo/出厂天眼可视系统指导说明书 （V2.0）.pdf"
             style="margin-left:4px;font-size:14px" target="_blank">{{ h_i18n('05fc98e2ae533822e4738bf085a5d1fe') }}</a>
        </h-col>
        <h-col :span="11">

        </h-col>
      </h-row>
      <h-row class="image_map_style_row">
        <div style="height:252px;
            width:652px;
            border:1px solid #ccc;
            background-color: rgb(236, 240, 245);
            background-image:url('@/assets/img/占位图.png');
            background-size: 300px;
            background-repeat: no-repeat;
            background-position-y: center;
            background-position-x: center;
            margin-left: 0px;
            position: relative;
            box-sizing: border-box;">
          <div style="position: absolute;top: 50%;left: 50%;z-index: 1;transform: translate(-50%,-50%);color:#CCC;">{{ h_i18n('919c190d10a36936e0383a3f84a11f80') }}</div>
          <div style="z-index: 2;position: relative;">
            <img
              :src="`${data.mapImg}?key=3fe923ca22501e073bc8c13b6e3b9a6b&location=${data.geocode}&zoom=10&size=650*250&markers=mid,,A:${data.geocode}`"
              alt=""/>
          </div>
        </div>
      </h-row>
      <template #footer>
        <div style="display:flex;">
          <div style="padding-right: 50px;padding-left: 25px;
          font-size: 14px !important;
          color: red;
          text-align: left;">{{ h_i18n('e4575bf1152f871cdf53e9786efda661') }}</div>
          <h-button-group align="right">
            <h-button type="primary" @click="clearData">
              <CloseOne></CloseOne>{{ h_i18n('625fb26b4b3340f7872b411f401e754c') }}</h-button>
            <h-button type="primary" @click="handleOkOfFactory" :loading="data.saveLoading">
              <template #icon>
                <Newlybuild theme="outline" />
              </template>{{ h_i18n('be5fbbe34ce9979bfb6576d9eddc5612') }}</h-button>
          </h-button-group>
        </div>
      </template>
    </h-dialog>

  </h-list-page>
</template>




<script setup>
//Automatic script writing.
import h_i18n from '@/utils/Internationalization';
import Encryption from "@/components/Encryption"
import encryptionApi from '@/components/Encryption/api.js'
import { reactive, getCurrentInstance, onMounted, ref, nextTick, onActivated, onDeactivated } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import axios from 'axios';
const { proxy, ctx } = getCurrentInstance();
const route = useRoute();
const router = useRouter();
const searchData = reactive({
  factoryName: null,
  pageNo: 1,
  pageSize: 10,
  citycode: 0,
})
const data = reactive({
  mapImg:'/mapOfApi/v3/staticmap',
  address:'',
  makeFactoryTitle: '',
  provinceList: [], // 省
  cityList: [], // 市
  areaList: [], // 区
  streetList: [], //街道
  geocode: '', // 坐标
  loading: false,
  tableData: [],
  factoryData: [],// 所有工厂
  btnListOfSqm: [],
  rowData: {}, // 工厂条目数据
  addData: {
    factoryProvince: '',
    factoryCity: '',
    factoryArea: '',
    subDistrict: '',
  }, // 工厂增改数据
  newFactoryFlag: false,
  saveLoading: false,
  tip: {
    tip_factoryName: { flag: false, color: 'red', text: h_i18n('42987c4e824fedc33d20d91af36e91be') },
    tip_factoryProvince: { flag: false, color: 'red', text: h_i18n('134026d3376cb5c2a888779112c30ff8') },
    tip_factoryCity: { flag: false, color: 'red', text: h_i18n('f168e7facce3c54389bc09e2c3e13b6d') },
    tip_factoryArea: { flag: false, color: 'red', text: h_i18n('a31683fc708db2d5f6fa6d75985b819c') },
    tip_subDistrict: { flag: false, color: 'red', text: h_i18n('361ce46f1fc778a36f50f916b79d0e84') },
    tip_detailedAddress: { flag: false, color: 'red', text: h_i18n('a95544272ec106cd637f4690ea5649c0') },
    // tip_appKey: { flag: false, color: 'red', text: h_i18n('87cff763038d9065ab3e24ce5ddac4a5') },
    // tip_secret: { flag: false, color: 'red', text: h_i18n('c28aadc2fadce43cc4c18a9bd39cf958') },
    // tip_deviceSerial: { flag: false, color: 'red', text: h_i18n('af0fad7f9a5709e112f2a2d79c5729d0') },
    // tip_equipmentModel: { flag: false, color: 'red', text: h_i18n('80018d8c24add6882b7b8cf5c2dd323e') },
  }
})
const placeHolderMsg = ref(h_i18n('708c9d6d2ad108ab2c560530810deae9'))
let tipExclude = []
let timeidOfTip = null
const cityFlag = ref(false)
const areaFlag = ref(false)
const subDistrictFlag = ref(false)
// 播放监控视频
const live = (row) => {
  let {href} = proxy.$router.resolve({
    name: 'live',
    query: {
      url: row.liveAddress,
      accessToken:row.accessToken,
    }
  })
  window.open(href, "_blank")
}
/* 传高度
*/
const changeMethod = () => {
  proxy.postThisPageHeight();
};
// 按钮事件
const btnFunction = (btnCode) => {
  switch (btnCode) {
    case "mkhl_cctyks_cctyks_insert":// 新建厂区
      creatNewFactoryShow('new')
      break;
  }
}
// loading事件
const loadingFunction = (btnCode) => {
  switch (btnCode) {
    case "mkhl_cctyks_cctyks_insert":// 新建厂区
      return
  }
}
// 获取数据
const getInfo = (flag) => {
  if (flag === true) {
    console.log(flag)
    searchData.pageNo = 1
  }
  data.loading = true
  proxy.$http({
    url: "/base/visualeye/searchFactory",
    method: 'post',
    data: {
      ...searchData,
      isJiaoHuSqe: "no",
      fixConfig: true,
    }
  }).then(res => {
    console.log(res)
    data.tableData = res.data.data.visualEyeDTOList
    data.total = res.data.data.visualEyeDTOPage.count
  }).catch(err => {

  }).finally(() => {
    data.loading = false
  })
}
// 获取数据
const getAllInfo = () => {
  proxy.$http({
    url: "/base/visualeye/searchFactory",
    method: 'post',
    data: {
      ...searchData,
      isJiaoHuSqe: "no",
      fixConfig: true,
      pageNo: 1,
      pageSize: 999999999,
    }
  }).then(res => {
    data.factoryData = res.data.data.visualEyeDTOList
  }).catch(err => {

  }).finally(() => {
  })
}

/** 新增/修改厂区 点击事件 */
const creatNewFactoryShow = (v, id, record) => {
  console.log('新增/修改厂区', v)
  data.newFactoryFlag = true
  proxy.postThisPageHeight()
  if (v === 'new') {
    data.makeFactoryTitle = h_i18n('c0f2a654866dcef0323065e21c5f7e7f')
    data.addData = {}
    data.geocode = null
    placeHolderMsg.value = h_i18n('708c9d6d2ad108ab2c560530810deae9')
    cityFlag.value = false
    areaFlag.value = false
    subDistrictFlag.value = false
    tipExclude = []
  } else if (v === "change") {
    data.makeFactoryTitle = h_i18n('ec7ad058bb0b8269b6535333512f1567')
    getRowData(record)
    // getAddress()
  }
  /** 获取省市区街联动数据 */
  searchProvinceCity()
}
/** 通过table表格行数据获取工厂数据  rowdata */
const getRowData = (record) => {
  for (let key in record) {
    data.rowData[key] = record[key]
  }
  for (let key in record) {
    data.addData[key] = record[key]
    // if(key === 'detailedAddress'){
    //   let promise = encryptionApi.decrypt(proxy,JSON.stringify([data.addData.detailedAddress]))
    //     promise.then(res=>{
    //     if(res.data.success == true && res.data.data && res.data.data.length == 1){
    //       data.addData.detailedAddress = res.data.data[0]
    //     }
    //   })
    // }
  }
  if (!data.rowData.factoryCity || data.rowData.factoryCity === "") {
    placeHolderMsg.value = h_i18n('21efd88b67a39834582ad99aabb9dc60')
    cityFlag.value = true
    areaFlag.value = true
    subDistrictFlag.value = true
    tipExclude = ['factoryCity', 'factoryArea', 'subDistrict']
  } else {
    tipExclude = []
    placeHolderMsg.value = h_i18n('708c9d6d2ad108ab2c560530810deae9')
    cityFlag.value = false
    areaFlag.value = false
    subDistrictFlag.value = false
    if (!data.rowData.factoryArea || data.rowData.factoryArea === "") {
      placeHolderMsg.value = h_i18n('21efd88b67a39834582ad99aabb9dc60')
      areaFlag.value = true
      subDistrictFlag.value = true
      tipExclude = ['factoryArea', 'subDistrict']
    } else {
      tipExclude = []
      placeHolderMsg.value = h_i18n('708c9d6d2ad108ab2c560530810deae9')
      cityFlag.value = false
      areaFlag.value = false
      subDistrictFlag.value = false
      if (!data.rowData.subDistrict || data.rowData.subDistrict === "") {
        placeHolderMsg.value = h_i18n('21efd88b67a39834582ad99aabb9dc60')
        subDistrictFlag.value = true
        tipExclude = ['subDistrict']
      } else {
        tipExclude = []
        placeHolderMsg.value = h_i18n('708c9d6d2ad108ab2c560530810deae9')
        cityFlag.value = false
        areaFlag.value = false
        subDistrictFlag.value = false
      }
    }
  }


  // data.rowData = record
  data.geocode = data.rowData.geoCode
  // data.addData = record
  // 根据获取静态地图
}
/** 判断厂区必填项 */
const mustHas = () => {
  return Object.keys(data.tip).every(v => {
    let item = v.slice(4)
    if (item == tipExclude[0] || item == tipExclude[1] || item == tipExclude[2]) {
      return true
    }
    if (data.addData[item] == '' || data.addData[item] == null || data.addData[item] == undefined) {
      data.tip[v].flag = true
      proxy.warning([data.tip[v].text])
      setTimeout(() => data.tip[v].flag = false, 2000)
      data.saveLoading = false
      return false
    } else {
      if (!searchData.supplyCode || searchData.supplyCode == "undefined" || searchData.supplyCode == "null" ||
        !searchData.supplyName || searchData.supplyName == "undefined" || searchData.supplyName == "null" ||
        !data.trueName || data.trueName == "undefined" || data.trueName == "null") {
        proxy.warning(h_i18n('9084b53e918cdc4e663473a22ea139fd'))
        data.saveLoading = false
        return false
      }
      return true
    }
  })
}
/** 添加/修改厂区 保存 按钮*/
const handleOkOfFactory = () => {
  data.saveLoading = true
  // console.log('addData.channelNo',data.addData.channelNo)
  clearTimeout(data.timeid)
  data.timeid = setTimeout(() => {


    getAddress()
    // console.log(mustHas())
    if (mustHas()) {
      if (!data.addData.id) {// 如果有id 就是修改 否则是新增
        // 新增判断厂区名是否重复
        let isSameFactoryName = data.factoryData.some(item => {
          return item.factoryName.trim() == data.addData.factoryName.trim()
        });
        if (isSameFactoryName) {
          proxy.warning(h_i18n('c004971dc1a114b46bd5ae55e9c26b16'))
          data.saveLoading = false
          return
        }

        //发送http请求保存数据
        // console.log("保存数据addData ====",data.addData)
        // channelNo 必须为数字
        data.addData.channelNo = parseInt(data.addData.channelNo)
        // console.log(typeof data.addData.channelNo,data.addData.channelNo)
        proxy.$http({
          url: "/base/visualeye/insertFactory", // 新建  1 成功， 0 失败
          method: 'post',
          data: {
            ...data.addData,
            supplyName: searchData.supplyName,
            supplyCode: searchData.supplyCode,
            yingshiStatus: data.addData.appKey ? 1 : 0, //萤石绑定状态
            isrtEmpId: data.trueName, //创建人
            monitorState: 0, //监控状态
            geoCode: data.geocode,
            isJiaoHuSqe: "no"
          }
        }).then((res) => {
          if (res.data.code == 200) {
            proxy.success(h_i18n('9652cad83cb49ebe7dc68241d83a3088') + res.data.msg)
            clearPAS()
            data.newFactoryFlag = false
            getInfo()
          } else {
            // clearPAS()
            proxy.warning(h_i18n('4d57314ab901e94823f4d85d32b17eb9') + res.data.msg)
          }
        }).finally(() => {
          data.saveLoading = false
        })
      } else {
        // 修改时判断厂区名是否重复
        let isSameFactoryName = data.factoryData.some(item => {
          if (item.factoryName == data.addData.factoryName) {
            if (item.id == data.addData.id) {
              return false
            } else {
              return true
            }
          } else {
            return false
          }
        });
        if (isSameFactoryName) {
          proxy.warning(h_i18n('395c105bdfe2a65e51f0bbdb91c7719e'))
          return
        }
        data.addData.channelNo = parseInt(data.addData.channelNo)
        proxy.$http({
          url: "/base/visualeye/updateFactory", // 更新 1 成功， 0 失败
          method: 'post',
          data: {
            ...data.addData,
            supplyName: searchData.supplyName,
            supplyCode: searchData.supplyCode,
            isrtEmpId: data.trueName, //创建人
            geoCode: data.geocode,
            isJiaoHuSqe: "no"
          }
        }).then((res) => {
          if (res.data.code == 200) {
            proxy.success(h_i18n('9652cad83cb49ebe7dc68241d83a3088') + res.data.msg)
            clearPAS()
            //  console.log(data.addData)
            data.newFactoryFlag = false
            data.saveLoading = false
            getInfo()
            getAllInfo()
          } else {
            proxy.warning(h_i18n('4d57314ab901e94823f4d85d32b17eb9') + res.data.msg)
            data.saveLoading = false
            // clearPAS()
          }
        })
      }
    }
  }, 1000);
}
/** 保存后清理市区街 */
const clearPAS = () => {
  data.cityList = null
  data.areaList = null
  data.streetList = null
}
/** 修改时回显行政区 */
const changeClick = (v) => {
  let a = null
  let b = null
  if (v === "factoryCity") {
    a = 'factoryProvince'
    b = 'cityList'
  } else if (v === 'factoryArea') {
    a = 'factoryCity'
    b = 'areaList'
  } else if (v === 'subDistrict') {
    a = 'factoryArea'
    b = 'streetList'
  }
  if (data.addData[a] && (!data[b] || data[b].length === 0)) {
    proxy.$http({
      url: `/mapOfApi/v3/config/district?key=3fe923ca22501e073bc8c13b6e3b9a6b&subdistrict=1&keywords=${data.addData[a]}`,
      method: 'get',
    }).then(res => {
      let i = 0
      if (res && res.data && res.data.districts?.length > 1) {
        i = res.data.districts.findIndex(item => item.name === data.addData[a])
        if (i === -1) i = 0
      }
      if (res.data.districts[i].districts == '') {
        return
      }
      data[b] = res.data.districts[i].districts
      // data[b] = res.data.districts[i].districts.map(item=>{
      //   return {value:item.name}
      // })
    }).catch(err => {
      console.log(err)
    }).finally(() => {

    })
  }
}


/** 高德地图 行政区 */
const searchProvinceCity = () => {
  proxy.$http({
    url: '/mapOfApi/v3/config/district?key=3fe923ca22501e073bc8c13b6e3b9a6b&subdistrict=1',
    method: 'get',


  }).then(res => {
    if (res.data.districts[0].districts == '') {
    }
    // data.provinceList = res.data.districts[0].districts.map(item=>{
    //   return {value:item.name}
    // })
    data.provinceList = res.data.districts[0].districts
  }).catch(err => {
    console.log(err)
  }).finally(() => {

  })
}
/**  选省 */
const changeProvince = (value) => {
  data.addData.factoryCity = ''
  data.addData.factoryArea = ''
  data.addData.subDistrict = ''
  data.areaList = null
  data.streetList = null
  proxy.$http({
    url: `/mapOfApi/v3/config/district?key=3fe923ca22501e073bc8c13b6e3b9a6b&keywords=${value}&subdistrict=1`,
    method: 'get',
  }).then(res => {
    if (res.data.districts[0].districts == '') {
      placeHolderMsg.value = h_i18n('21efd88b67a39834582ad99aabb9dc60')
      cityFlag.value = true
      areaFlag.value = true
      subDistrictFlag.value = true
      tipExclude = ['factoryCity', 'factoryArea', 'subDistrict']
      getAddress()
    } else {
      tipExclude = []
      placeHolderMsg.value = h_i18n('708c9d6d2ad108ab2c560530810deae9')
      cityFlag.value = false
      areaFlag.value = false
      subDistrictFlag.value = false
    }
    data.cityList = res.data.districts[0].districts
    // data.cityList = res.data.districts[0].districts.map(item=>{
    //   return {value:item.name}
    // })
  }).catch(err => {
    console.log(err)
  }).finally(() => {

  })
}
/** 选市 */
const changeCity = (value) => {
  data.addData.factoryArea = ''
  data.addData.subDistrict = ''
  data.streetList = null
  proxy.$http({
    url: `/mapOfApi/v3/config/district?key=3fe923ca22501e073bc8c13b6e3b9a6b&keywords=${value}&subdistrict=1`,
    method: 'get',
  }).then(res => {
    let i = 0
    if (res && res.data && res.data.districts?.length > 1) {
      i = res.data.districts.findIndex(item => item.name === value)
      if (i === -1) i = 0
    }
    if (res.data.districts[i].districts == '') {
      placeHolderMsg.value = h_i18n('21efd88b67a39834582ad99aabb9dc60')
      areaFlag.value = true
      subDistrictFlag.value = true
      tipExclude = ['factoryArea', 'subDistrict']
      getAddress()
    } else {
      tipExclude = []
      placeHolderMsg.value = h_i18n('708c9d6d2ad108ab2c560530810deae9')
      cityFlag.value = false
      areaFlag.value = false
      subDistrictFlag.value = false
    }
    data.areaList = res.data.districts[i].districts
    // data.areaList = res.data.districts[i].districts.map(item=>{
    //   return {value:item.name}
    // })
    data.citycode = res.data.districts[i].citycode
  }).catch(err => {
    console.log(err)
  }).finally(() => {

  })
}
/** 选区 */
const changeArea = (value, e) => {
  data.addData.subDistrict = ''
  data.streetList = []
  proxy.$http({
    url: `/mapOfApi/v3/config/district?key=3fe923ca22501e073bc8c13b6e3b9a6b&keywords=${value}&subdistrict=1`,
    method: 'get',
  }).then(res => {
    let i = 0
    if (res && res.data && res.data.districts?.length > 1) {
      i = res.data.districts.findIndex(item => item.name === value && data.citycode === item.citycode)
      if (i === -1) i = 0
    }
    if (res.data.districts[i].districts == '') {
      placeHolderMsg.value = h_i18n('21efd88b67a39834582ad99aabb9dc60')
      subDistrictFlag.value = true
      tipExclude = ['subDistrict']
      getAddress()
    } else {
      tipExclude = []
      placeHolderMsg.value = h_i18n('708c9d6d2ad108ab2c560530810deae9')
      cityFlag.value = false
      areaFlag.value = false
      subDistrictFlag.value = false
    }
    let areaTemp = res.data.districts.filter((item) => {
      if (item.citycode == data.citycode) {
        return item
      }
    })
    data.streetList = areaTemp[0].districts
    // data.streetList = areaTemp[0].districts.map(item=>{
    //   return {value:item.name}
    // })
    // data.streetList = res.data.districts[i].districts.map(item=>{
    //   return {value:item.name}
    // })
    // data.adcodeOfArea = res.data.districts[i].adcode
    // console.log(data.streetList)
  }).catch(err => {
    console.log(err)
  }).finally(() => {

  })
}
/** 地理编码 */
const getGeocode = () => {
  proxy.$http({
    url: `/mapOfApi/v3/geocode/geo?key=3fe923ca22501e073bc8c13b6e3b9a6b&address=${data.address}`,
    method: 'get',
  }).then(res => {
    // console.log(res)
    if (res.data.status == 0) {
      let newAddress = ''
      data.addData.factoryProvince ? newAddress += data.addData.factoryProvince : newAddress += ''
      data.addData.factoryCity ? newAddress += data.addData.factoryCity : newAddress += ''
      data.addData.factoryArea ? newAddress += data.addData.factoryArea : newAddress += ''
      data.addData.subDistrict ? newAddress += data.addData.subDistrict : newAddress += ''

      proxy.$http({
        url: `/mapOfApi/v3/geocode/geo?key=3fe923ca22501e073bc8c13b6e3b9a6b&address=${newAddress}`,
        method: 'get',
      }).then(res => {
        if (res.data.status == 0) {
          return
        }
        data.geocode = res.data.geocodes[0].location
      }).catch(err=>{
        console.log(err)
      })
      return
    }
    data.geocode = res.data.geocodes[0].location
    // console.log("地理编码:",data.geocode)
  }).catch(err => {
    console.log(err)
  }).finally(() => {

  })
}
/** 选街 */
const changeStreet = (value) => {
  getAddress()
}
/** 拼接地址 */
const getAddress = () => {
  data.address = ''
  data.addData.factoryProvince ? data.address += data.addData.factoryProvince : data.address += ''
  data.addData.factoryCity ? data.address += data.addData.factoryCity : data.address += ''
  data.addData.factoryArea ? data.address += data.addData.factoryArea : data.address += ''
  data.addData.subDistrict ? data.address += data.addData.subDistrict : data.address += ''
  data.addData.detailedAddress ? data.address += data.addData.detailedAddress : data.address += ''
  // console.log(data.address)
  getGeocode()
}
/** 取消增改 */
const clearData = () => {
  clearPAS()
  // console.log(data.addData)
  // console.log(data.rowData)
  data.newFactoryFlag = false
}
/** 非number提示(可以为空) */
const inputNumberChange = (e) => {
  if (new RegExp('^[0-9]*$').test(data.addData.channelNo)) {
  } else {
    if (data.addData.channelNo == '') { return }
    data.addData.channelNo = null
  }

}


onMounted(() => {
  if (route.query) {
    data.supplyCode = route.query.supplyCode;
    searchData.supplyCode = route.query.supplyCode;
    searchData.supplyName = route.query.supplyName;
    data.supplyName = route.query.supplyName;
    data.trueName = route.query.trueName;
    data.roleCode = route.query.roleCode;
    data.userName = route.query.userName;
    // searchData.applyName = route.query.trueName;
    // searchData.trueName = route.query.trueName;
    // searchData.relatedRoleId = route.query.roleId;
    // searchData.roleCode = route.query.roleCode;
  }
  if (route.query.dataFrom != 'sqm') {
    proxy.$router.replace('/404')
    return
  }
  if (!route.query.supplyCode) {
    proxy.info({
      title: h_i18n('02d9819ddaaaeb1b7b22b12608c7e5ca'), message: h_i18n('c0f92e28b64a4268408f10aa60dc47c8'), confirmButtonText: h_i18n('38cf16f2204ffab8a6e0187070558721'),
      callback: (action) => {
        proxy.$router.back()
      },
    })
    return
  }
  getInfo()
  if (route.query.parentId && route.query.parentId != 'null' && route.query.parentId != 'undefined' && route.query.parentId != '') {
    let p = proxy.getButtonFromSqm(route.query.parentId, route.query.roleCode)
    p.then(res => {
      if (res.length > 0) {
        data.btnListOfSqm = res
        console.log(data.btnListOfSqm)
      }
    })
  }
  getAllInfo()
  if(process.env.NODE_ENV === 'production'){
    data.mapImg = '/workBench' + data.mapImg
  }else if(process.env.NODE_ENV === "test"){
    data.mapImg = '/sqm-workbench' + data.mapImg
  }
})
</script>

<style lang="scss">
.isFactoryvisualEye_style {
  .dialog_factoryvisualeye_style {
    .haier-dialog {
      top: 5%;
      .haier-dialog--body {
        .haier-row {
          justify-content: center;

          .haier-col:last-child {
            width: calc(100% - 32px) !important;
            padding-right: 0px !important;

            .haier-search {
              width: calc(100% - 32px) !important;
              margin-right: 0px !important;
            }

          }
        }
      }
    }

    // .image_map_style_row {}

    .el-input__inner {
      padding-left: 92px !important;
      height: 32px !important;
    }

    .el-textarea__inner {
      border-radius: 4px;
      border: 1px solid #ccc;
      width: 652px;
      padding-left: 92px;
    }

    .el-textarea::before {
      content: var(--content);
      position: absolute;
      font-size: 14px;
      padding-left: 10px;
      padding-top: 7.5px;
      color: #1D2129;
    }
  }
}
</style>